<div class="h-full flex flex-col docu-sign-bg"
    [style.backgroundImage]="'url(' + ('images/docu-bg.png' | assetUrl) + ')'">
    <div class="w-full h-full flex flex-col justify-around">
        <div class="gradient-container relative flex flex-col items-center justify-around gap-2 mt-4">
            <div class="gradient-background"></div>
            <div class="flex p-[0.15rem] rounded-xl border border-arena-orange-100 bg-arena-orange-50/1 relative z-10">
                <div class="">
                    <div class="flex p-4 border bg-white rounded-xl">
                        <div class="flex items-center justify-center gap-2">
                            <img width="120" height="120" [src]="'images/docu-name.png' | assetUrl" alt="Docusign logo">
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col items-center space-y-1.5 relative z-10">
                @for(dot of dots; track $index){
                <div class="h-1 w-1 rounded-full bg-orange-400/80"></div>
                }
            </div>
            <div class="flex p-[0.15rem] rounded-xl border border-arena-orange-100 bg-arena-orange-50/1 relative z-10">
                <div class="">
                    <div class="flex p-4 border bg-white rounded-xl">
                        <img width="100" [src]="'images/logos/innDocAI-themed.png' | assetUrl" alt="InnDoc logo">
                    </div>
                </div>
            </div>
        </div>
        @if(lastSynced){
        <div class="flex flex-col items-center gap-2">
            <div class="px-1.5  rounded-lg " [ngClass]="{'bg-green-100': consentExists, 'bg-red-100': !consentExists}">
                <span class="font-medium"
                    [ngClass]="{'text-green-700': consentExists, 'text-red-700': !consentExists}">{{
                    consentExists ? 'Connected' : 'Disconnected' }}</span>
            </div>
            <p class="mt-3 text-sm text-gray-500 font-medium">
                Last synced on <span class="text-gray-700 font-medium">{{ lastSynced }}</span>
            </p>
        </div>
        }
        <div class="flex flex-col  mt-4">
            <div>
                <div class="d-flex">
                    <form [formGroup]="docuForm">
                        <div class="mb-2">
                            <div><label for="apiAccountId">API Account ID</label></div>
                            <div>
                                <input type="text" id="apiAccountId" placeholder="Api Account ID"
                                    class="p-2 w-full border bg-transparent" pInputText formControlName="apiAccountId">
                            </div>
                        </div>
                        <div>
                            <div><label for="clientId">Client Key</label></div>
                            <div>
                                <input type="text" id="clientId" placeholder="Client Id"
                                    class="p-2 w-full border bg-transparent" pInputText formControlName="clientId">
                            </div>
                        </div>
                        <div class="mt-4">
                            <div><label for="clientSecret">Client Secret Key</label></div>
                            <div class="">
                                <p-password id="clientSecret" type="password" formControlName="clientSecret"
                                    class="w-full" [feedback]="false" placeholder="Password"
                                    class="p-password p-component p-inputwrapper p-input-icon-right rounded bg-transparent"
                                    [style]="{'width':'100%'}" [inputStyle]="{'width':'100%','padding' : '8px'}"
                                    [toggleMask]="true"></p-password>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="flex mt-6 gap-4 justify-between">
                    <div class="flex-1">
                        <app-button variant="outlined" severity="contrast" label="Save"
                            (clicked)="saveDocuSignSettings()" />
                    </div>
                    <div class="flex gap-2 items-center">
                        <app-button variant="outlined" severity="contrast" label="Revoke" (clicked)="revokeConsent()"
                            [disabled]="!consentExists || revokeLoading" [loading]="revokeLoading" />
                        <app-button variant="filled" severity="primary"
                            label="{{consentExists ? 'Connected' : 'Connect'}}" [disabled]="consentExists"
                            [loading]="connectLoading" (clicked)="getConsentCode()" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
